import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './PaymentPage.css'; // Import the CSS file

const PaymentPage = () => {
  const navigate = useNavigate();
  const [phoneNumber, setPhoneNumber] = useState(''); // State for phone number
  const [loading, setLoading] = useState(false); // To show loading during payment initiation
  const carData = JSON.parse(localStorage.getItem('carSourcingData')); // Retrieve form data from localStorage

  useEffect(() => {
    if (!carData) {
      navigate('/'); // If no car data, redirect to form
    }
  }, [carData, navigate]);

  const handlePayment = async () => {
    if (!phoneNumber || phoneNumber.length !== 12 || !phoneNumber.startsWith('254')) {
      alert('Please enter a valid phone number in the format 254XXXXXXXXX');
      return;
    }

    setLoading(true); // Set loading state to true

    // Make a call to your backend to initiate Daraja payment
    const response = await fetch('https://cardealer-backend-shac.onrender.com/api/payments/daraja', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ phoneNumber, carData, amount: 2500 }), // Send phone number, car data, and amount
    });

    const paymentData = await response.json();
    setLoading(false); // Set loading state to false

    if (paymentData.success) {
      alert('Payment initiated. Please complete the payment on your phone.');
      navigate('/payment-success'); // Redirect to success page after initiating payment
    } else {
      alert(paymentData.message || 'Payment initiation failed. Please try again.');
    }
  };

  return (
    <div className="payment-page">
      <h2>Payment for Sourcing</h2>
      <p>You're paying Ksh 2500 for sourcing the perfect car.</p>
      
      {/* Input for phone number */}
      <div>
        <label>Enter your phone number (e.g., 254XXXXXXXXX):</label>
        <input 
          type="text" 
          value={phoneNumber} 
          onChange={(e) => setPhoneNumber(e.target.value)} 
          placeholder="254XXXXXXXXX"
          required 
        />
      </div>

      {/* Button to initiate payment */}
      <button onClick={handlePayment} disabled={loading}>
        {loading ? 'Processing...' : 'Initiate Payment'}
      </button>
    </div>
  );
};

export default PaymentPage;
